/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['zappos', '\36', 'findzen', 'versional', 'rookieusa'] }] */
import cn from 'classnames';

import { MERCHANTID_MARKET_NAME_MAPPING } from 'helpers/MarketplaceUtils';
import ZapposLogo from 'images/zappos/logo-black.svg';
import SixpmLogo from 'images/6pm/logo-black.svg';
import RookieUsaLogo from 'images/rookieusa/logo-black.svg';
import VrsnlLogo from 'images/vrsnl/logo-black.svg';
import FindZenLogo from 'images/zen/logo-black.svg';

import css from 'styles/components/cart/itemMerchantLogo.scss';

const marketNameLogoMap = {
  'zappos': ZapposLogo,
  '6pm': SixpmLogo,
  'rookieusa': RookieUsaLogo,
  'findzen': FindZenLogo,
  'versional': VrsnlLogo
};
export const ItemMerchantLogo = ({ merchantId }) => {
  const marketName = MERCHANTID_MARKET_NAME_MAPPING[merchantId];
  if (!marketName) {
    return null;
  }

  return <p className={cn(css.container, css[marketName])}><img src={marketNameLogoMap[marketName]} alt={marketName} /></p>;
};

export default ItemMerchantLogo;
